let language = {
    "RESOURCE-LIBRARY-ALERT-CREATE-FAIL-TITLE":"Create fail",
    "RESOURCE-LIBRARY-ALERT-CREATE-FAIL-CONTENT":"The maximum limit for directory folders is 20.",
    "RESOURCE-LIBRARY-ALERT-DELETE-SELECTED-FILE-TITLE":"Delete files",
    "RESOURCE-LIBRARY-ALERT-DELETE-SELECTED-FILE-CONTENT":"Are you sure to delete selected files?",
    "RESOURCE-LIBRARY-ALERT-DELETE-FILE-TITLE":"Delete file",
    "RESOURCE-LIBRARY-ALERT-DELETE-FILE-CONTENT":"Are you sure to delete selected file?",
    "RESOURCE-LIBRARY-ALERT-DELETE-FOLDER-TITLE":"Delete folder",
    "RESOURCE-LIBRARY-ALERT-DELETE-FOLDER-CONTENT":"Are you sure to delete selected folder?",
};

export { language }